
import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import Icon from "../../common/icon/icon.component"
import SideBar from "../../common/layout/sidebar.component.jsx"
import ProductTabs from "../../common/layout/tabs/products.component"
import StandardList from "../../common/listing/list.component"
import SortLink from "../../common/listing/sortlink.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import { ListingSortFieldAndOrder } from "../../state/listing/ListingSortField"
import PriceLevel from "../../state/price-level/PriceLevel"
import { fetchPriceLevels, sortPriceLevelsAction } from "../../state/price-level/PriceLevelActions"
import { getPriceLevels } from "../../state/price-level/PriceLevelSelector"


const PriceLevelListing = () => {
    const priceLevels = useSelector(state => getPriceLevels(state))
    const dispatch = useDispatch()
    const [listingSortFieldAndOrder, setListingSortFieldAndOrder] =
        useState<ListingSortFieldAndOrder>({ sortField: "name", sortOrderAsc: false })

    useEffect(() => {
        SideBar.activateMenu("product")
        dispatch(fetchPriceLevels())
    }, [])

    const handleSortLinkChange = (listingSortParam: ListingSortFieldAndOrder) => {
        setListingSortFieldAndOrder({ sortField: listingSortParam.sortField, sortOrderAsc: listingSortParam.sortOrderAsc })
        dispatch(sortPriceLevelsAction({ sortField: listingSortParam.sortField, sortOrderAsc: listingSortParam.sortOrderAsc }))
    }

    const headers = [
        <SortLink
            field={"name"}
            key={"priceLevelNameHeader"}
            sortField={listingSortFieldAndOrder.sortField}
            asc={listingSortFieldAndOrder.sortOrderAsc}
            onChange={(sortField, asc) => {
                handleSortLinkChange({ sortField: sortField, sortOrderAsc: asc })
            }}
        >
            <FormattedMessage
                id="product.price_level.price_level_name"
                defaultMessage="Name"
            />
        </SortLink>,
    ]

    const rows = (priceLevel: PriceLevel) => {
        return [
            <p className="m-0" key={priceLevel.getId()}>
                <Link to={`/priceLevels/edit/${priceLevel.getId()}`}>{priceLevel.getName()}</Link>
            </p>,
        ]
    }

    if (!priceLevels) {
        return <LoadingSpinner />
    }

    return < div >
        <ProductTabs />
        <div className="row ui-has-modules py-1">
            <div className="col-12 ui-module mb-0">
                <div className="row mb-0 justify-content-end">
                    <div className="col-3 text-align-right ">
                        <Link to="/priceLevels/new" className="btn btn-primary">
                            <Icon value={"plus-circle"} />
                            <FormattedMessage
                                id="product.price_level.listing.add_price_level_btn"
                                defaultMessage="Add Price Level"
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        <StandardList
            smallLine={true}
            className="row pt-3"
            headers={headers}
            rows={priceLevels?.map(pl => rows(pl))}
        />
    </div >
}

export default injectIntl(PriceLevelListing)


// WEBPACK FOOTER //
// ./src/product/price-level/PriceLevelListing.tsx